"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Notification_1 = require("../Notification");
var react_1 = require("@monaco-editor/react");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var Tree_1 = require("../../components/Tree");
var InteractionNotification = /** @class */ (function (_super) {
    __extends(InteractionNotification, _super);
    function InteractionNotification(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleInteractionModal = function () {
            if (!_this.state.showInteraction) {
                _this.supportPortalService.logAgentActivity(_this.props.customer, {
                    "action": "Show Interaction",
                    "customer": _this.props.interaction.agreementNumber
                }).subscribe();
            }
            _this.setState(function (prevState) { return ({
                showInteraction: !prevState.showInteraction
            }); });
        };
        _this.state = {
            showInteraction: false
        };
        return _this;
    }
    InteractionNotification.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsx)("button", { className: "btn-text cursor-pointer text-decoration-none on-hover-underline", onClick: this.toggleInteractionModal, children: "Show interaction" }) }), (0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.showInteraction, hide: this.toggleInteractionModal, title: "Interaction", body: ((0, jsx_runtime_1.jsx)(react_1.default, { height: "100%", width: "100%", language: "json", value: JSON.stringify(this.props.interaction, null, 4), onMount: function (editor, monaco) { return editor.focus(); } })), style: {
                        maxHeight: "100%",
                        height: "100%",
                        margin: "0",
                        maxWidth: "100%",
                        width: "100%"
                    } })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], InteractionNotification.prototype, "supportPortalService", void 0);
    InteractionNotification = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], InteractionNotification);
    return InteractionNotification;
}(React.Component));
exports.default = InteractionNotification;
//# sourceMappingURL=InteractionNotification.js.map